export class UserProfileDto {
  public language: string
}
